import { render, staticRenderFns } from "./CloudFoto.vue?vue&type=template&id=22915635"
import script from "./CloudFoto.vue?vue&type=script&lang=js"
export * from "./CloudFoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports